/* unplugin-vue-components disabled */import { render } from "./MyCommunities.vue?vue&type=template&id=eaf36968&scoped=true"
import script from "./MyCommunities.vue?vue&type=script&lang=js"
export * from "./MyCommunities.vue?vue&type=script&lang=js"

import "./MyCommunities.vue?vue&type=style&index=0&id=eaf36968&lang=scss&scoped=true"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf36968"]])

export default __exports__